var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRepatriation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.664062,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6641 48.3557L28.5068 52.1238L32.3214 60L36.9457 55.3808L36.6781 50.4942L41.5865 45.5912L54.6642 58.6584L59.5711 53.7569L51.3947 35.794C51.3947 35.794 54.6746 32.5274 56.3022 30.8919L56.3243 30.8698C57.9735 29.2127 62.8158 24.3472 59.5671 21.0986C56.3038 17.8353 51.3899 22.724 49.7637 24.3607C48.1375 25.9974 44.8508 29.2615 44.8508 29.2615L26.87 21.0919L21.9629 25.9935L34.8207 38.8371L29.9128 43.7365H27.6006H25.2884L20.6641 48.3557Z",
    fill: "url(#paint0_linear_25933_4777)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25933_4777",
    x1: 24.6641,
    y1: 31,
    x2: 14.3121,
    y2: 57.3633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#A2A0FA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRepatriation);
export default __webpack_public_path__ + "static/media/icon-repatriation.25b7dceedc41c6d548648a45d6702c49.svg";
export { ForwardRef as ReactComponent };